(function (root, factory) {
  'use strict';

  if (typeof module === 'object' && module.exports) {
    module.exports = factory;
    return;
  }

  if (root.CentralSportExpressDeliveryBadge && root.CentralSportExpressDeliveryBadge.namespace === 'cs-express-delivery-badge') {
    return;
  }

  root.CentralSportExpressDeliveryBadge = factory(root);
})(typeof window !== 'undefined' ? window : globalThis, function createExpressDeliveryBadge(runtime) {
  'use strict';

  var SETTINGS_SELECTOR = '[data-cs-express-delivery-settings]';
  var SETTINGS_TYPE = 'cs-express-delivery-badge-settings';
  var CONFIG_EVENT = 'cs:express-delivery:config-updated';
  var DELIVERY_EVENT = 'cs:express-delivery:updated';
  var DEFAULTS = {
    enabled: true,
    todayText: 'Llega hoy',
    nextBusinessDayText: 'Llega el siguiente día hábil',
    weekendText: 'Compra hoy, procesamos el próximo día hábil',
    nonOperationalText: 'Envíos en pausa',
    fallbackText: 'Entrega rápida',
    backgroundColor: '#fff3e8',
    textColor: '#713000'
  };
  var config = Object.assign({}, DEFAULTS);
  var activeSectionId = '';
  var documentRef = runtime && runtime.document;

  function parseBoolean(value, fallback) {
    if (value === true || value === 'true') return true;
    if (value === false || value === 'false') return false;
    return fallback;
  }

  function readSettings(element) {
    if (!element || !element.dataset) return Object.assign({}, DEFAULTS);
    return {
      enabled: parseBoolean(element.dataset.enabled, DEFAULTS.enabled),
      todayText: element.dataset.todayText || DEFAULTS.todayText,
      nextBusinessDayText: element.dataset.nextBusinessDayText || DEFAULTS.nextBusinessDayText,
      weekendText: element.dataset.weekendText === undefined ? DEFAULTS.weekendText : element.dataset.weekendText,
      nonOperationalText: element.dataset.nonOperationalText === undefined
        ? DEFAULTS.nonOperationalText
        : element.dataset.nonOperationalText,
      fallbackText: element.dataset.fallbackText || DEFAULTS.fallbackText,
      backgroundColor: element.dataset.backgroundColor || DEFAULTS.backgroundColor,
      textColor: element.dataset.textColor || DEFAULTS.textColor
    };
  }

  function findSettings(scope) {
    if (!scope) return null;
    if (typeof scope.matches === 'function' && scope.matches(SETTINGS_SELECTOR)) return scope;
    return typeof scope.querySelector === 'function' ? scope.querySelector(SETTINGS_SELECTOR) : null;
  }

  function applyCssVariables(nextConfig) {
    var rootElement = documentRef && documentRef.documentElement;
    if (!rootElement || !rootElement.style) return;
    rootElement.style.setProperty('--cs-express-badge-background', nextConfig.backgroundColor);
    rootElement.style.setProperty('--cs-express-badge-text', nextConfig.textColor);
  }

  function createConfigEvent() {
    if (runtime && typeof runtime.CustomEvent === 'function') {
      return new runtime.CustomEvent(CONFIG_EVENT, { detail: { config: Object.assign({}, config) } });
    }
    return { type: CONFIG_EVENT, detail: { config: Object.assign({}, config) } };
  }

  function notifyConfigUpdated() {
    if (documentRef && typeof documentRef.dispatchEvent === 'function') {
      documentRef.dispatchEvent(createConfigEvent());
    }
  }

  function setConfig(nextConfig, notify) {
    config = Object.assign({}, DEFAULTS, nextConfig || {});
    applyCssVariables(config);
    if (notify !== false) notifyConfigUpdated();
    return Object.assign({}, config);
  }

  function configureFromElement(element, notify) {
    if (!element || element.dataset.sectionType !== SETTINGS_TYPE) return false;
    activeSectionId = element.dataset.sectionId || activeSectionId;
    setConfig(readSettings(element), notify);
    return true;
  }

  function getPresentation(engine, currentConfig) {
    var badgeConfig = Object.assign({}, DEFAULTS, currentConfig || {});
    function withText(text, status) {
      var normalized = String(text || '').replace(/\u00a0/g, ' ').trim();
      return { visible: normalized !== '', text: normalized, status: status };
    }
    if (!badgeConfig.enabled) return { visible: false, text: '', status: 'disabled' };
    if (!engine || typeof engine.resolveDelivery !== 'function') {
      return withText(badgeConfig.fallbackText, 'fallback');
    }

    try {
      var result = engine.resolveDelivery({ product: { eligible: true, available: true } });
      if (result && result.visible === false) {
        return { visible: false, text: '', status: result.status || result.state || 'unavailable' };
      }
      if (result && result.status === 'today') {
        return withText(badgeConfig.todayText, 'today');
      }
      if (result && result.status === 'next_business_day') {
        return withText(badgeConfig.nextBusinessDayText, 'next_business_day');
      }
      if (result && result.status === 'weekend') return withText(badgeConfig.weekendText, 'weekend');
      if (result && (result.status === 'holiday' || result.status === 'blackout')) {
        return withText(badgeConfig.nonOperationalText, result.status);
      }
      return withText(badgeConfig.fallbackText, 'fallback');
    } catch (error) {
      return withText(badgeConfig.fallbackText, 'fallback');
    }
  }

  function updateBadge(element) {
    if (!element || typeof element.querySelector !== 'function') return;
    var engine = runtime && runtime.CentralSportExpressDelivery;
    var presentation = getPresentation(engine, config);
    var textElement = element.querySelector('[data-cs-express-delivery-badge-text]');

    element.hidden = !presentation.visible;
    element.dataset.csStatus = presentation.status;
    element.setAttribute('aria-label', presentation.text);
    if (textElement) textElement.textContent = presentation.text;
  }

  function onSectionLoad(event) {
    var settings = findSettings(event && event.target);
    configureFromElement(settings, true);
  }

  function onSectionUnload(event) {
    var settings = findSettings(event && event.target);
    if (!settings || settings.dataset.sectionType !== SETTINGS_TYPE) return;
    if (activeSectionId && settings.dataset.sectionId && settings.dataset.sectionId !== activeSectionId) return;
    activeSectionId = '';
    setConfig(Object.assign({}, DEFAULTS, { enabled: false }), true);
  }

  function registerCustomElement() {
    if (!runtime || !runtime.customElements || !runtime.HTMLElement) return;
    if (runtime.customElements.get('cs-express-delivery-badge')) return;

    class CsExpressDeliveryBadge extends runtime.HTMLElement {
      constructor() {
        super();
        this.csHandleUpdate = this.csHandleUpdate.bind(this);
      }

      csHandleUpdate() {
        updateBadge(this);
      }

      connectedCallback() {
        if (this.csListening || !documentRef) return;
        this.csListening = true;
        documentRef.addEventListener(CONFIG_EVENT, this.csHandleUpdate);
        documentRef.addEventListener(DELIVERY_EVENT, this.csHandleUpdate);
        updateBadge(this);
      }

      disconnectedCallback() {
        if (!this.csListening || !documentRef) return;
        documentRef.removeEventListener(CONFIG_EVENT, this.csHandleUpdate);
        documentRef.removeEventListener(DELIVERY_EVENT, this.csHandleUpdate);
        this.csListening = false;
      }
    }

    runtime.customElements.define('cs-express-delivery-badge', CsExpressDeliveryBadge);
  }

  if (documentRef) {
    var initialSettings = findSettings(documentRef);
    if (initialSettings) configureFromElement(initialSettings, false);
    else applyCssVariables(config);
    registerCustomElement();
    documentRef.addEventListener('shopify:section:load', onSectionLoad);
    documentRef.addEventListener('shopify:section:unload', onSectionUnload);
  }

  return Object.freeze({
    namespace: 'cs-express-delivery-badge',
    version: '1.1.0',
    getConfig: function () { return Object.assign({}, config); },
    readSettings: readSettings,
    setConfig: setConfig,
    configureFromElement: configureFromElement,
    getPresentation: getPresentation,
    updateBadge: updateBadge,
    onSectionLoad: onSectionLoad,
    onSectionUnload: onSectionUnload
  });
});
